import { useBucket } from '@mc/experiments-react'
import { useIsSubscriptionsExpEligible } from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'
import {
  MCCERTS_3255_MC_PRO_IN_CERTS_FLAG,
  type McProInCertsBucket,
} from '../constants'

export const useIsMcProInCertsExpActive = (
  props: Parameters<typeof useIsSubscriptionsExpEligible>[0],
): boolean => {
  const isEligible = useIsSubscriptionsExpEligible(props)
  const bucket = useBucket<McProInCertsBucket>(
    MCCERTS_3255_MC_PRO_IN_CERTS_FLAG,
  )
  return isEligible && !!bucket
}
